import React from "react";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { useOnClickOutside } from "@hooks/useOnClickOutside";
import { useTelemetry } from "@hooks/useTelemetry";

import { Props } from "./Dropdown.types";
import * as Styled from "./Dropdown.styled";

export const Dropdown: React.FC<React.PropsWithChildren<Props>> = ({
  eventId = "dropdownButton",
  isActive,
  setIsActive,
  ...props
}) => {
  const { elementClick } = useTelemetry();

  const $root = useOnClickOutside<HTMLDivElement>(() => {
    setIsActive(false);
  });

  const toggleState = (event: React.MouseEvent<HTMLElement>) => {
    setIsActive(c => !c);

    elementClick(props.eventLabel || event.currentTarget.textContent || "", {
      buttonId: eventId,
      context: {
        open: !isActive,
      },
    });
  };

  return (
    <Styled.Root ref={$root}>
      <TestWrapper testId={props.testIds?.button}>
        <Styled.Button
          onClick={toggleState}
          $style={{ default: "medium_14", smallDesktop: "medium_18" }}
          $hoverColor={props.hoverColor}
        >
          <Styled.Label $ellipsis={props.labelEllipsis}>
            {props.label}
          </Styled.Label>
          <Styled.ArrowIcon width={20} $isActive={isActive} />
        </Styled.Button>
      </TestWrapper>

      <TestWrapper testId={props.testIds?.panel}>
        <Styled.Panel
          $position={props.position || "right"}
          $distance={props.distance || 0}
          $isActive={isActive}
          $zIndex={props.zIndex}
        >
          {props.children}
        </Styled.Panel>
      </TestWrapper>
    </Styled.Root>
  );
};
